import React from 'react';
import { Link } from 'react-router-dom';
import ShoppingCart from './ShoppingCart';
import UserProfile from './UserProfile';
import { useAuth } from '../context/AuthContext';
import Logo from './Logo';
import DropdownMenu from './DropdownMenu';

const Header: React.FC = () => {
  const { isAuthenticated } = useAuth();
  return (
    <header className="header futuristic-header">
      <div className="header-bg"></div>
      <div className="container">
        <Link to="/" className="logo-link">
          <Logo className="header-logo" width={180} height={50} />
        </Link>
        <div className="header-right">
          <nav>
            <ul>
              <li><Link to="/"><span className="nav-icon">🏠</span> Home</Link></li>
              <DropdownMenu
                label="Solutions"
                icon="🤖"
                items={[
                  { path: "/employees", icon: "👾", label: "AI Employees" },
                  { path: "/build-employee", icon: "🛠️", label: "Build AI Employee" }
                ]}
              />
              <DropdownMenu
                label="Features"
                icon="✨"
                items={[
                  { path: "/browse", icon: "📂", label: "Browse" },
                  { path: "/search", icon: "🔍", label: "Search" },
                  { path: "/chat", icon: "💬", label: "Neural Chat" },
                  { path: "/collaboration", icon: "🧑‍🦲", label: "AI Collaboration" }
                ]}
              />
              <DropdownMenu
                label="Learn"
                icon="📚"
                items={[
                  { path: "/demo", icon: "💻", label: "Demo" },
                  { path: "/how-it-works", icon: "💡", label: "How It Works" },
                  { path: "/faq", icon: "💬", label: "FAQ" }
                ]}
              />
              <li><Link to="/pricing"><span className="nav-icon">💲</span> Pricing</Link></li>
              <li><Link to="/api"><span className="nav-icon">🔗</span> API</Link></li>
              <li><Link to="/about"><span className="nav-icon">ℹ️</span> About</Link></li>
              <li><Link to="/contact"><span className="nav-icon">📞</span> Contact</Link></li>
            </ul>
          </nav>
          <ShoppingCart />
          {isAuthenticated ? (
            <UserProfile />
          ) : (
            <Link to="/login" className="login-button">
              <span className="login-icon">👤</span>
              Login
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
